import { Message, Pagination, Loading } from "element-ui";
const element = {
  install: function(Vue) {
    Vue.use(Pagination);
    Vue.use(Loading);
    Vue.prototype.$message = Message;
  }
};

export default element;



// WEBPACK FOOTER //
// ./src/element/index.js